import React, { useState } from "react";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import moment from "moment";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import {
  useItemsFilter,
  useItemsFilterNew,
} from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { toast } from "react-toastify";
import { initialState } from "../constants/_constant";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";
import { MdClear } from "react-icons/md";
import "../css/pgeneralInfo.css";

const PGeneralInfo = ({
  displayData,
  handleChange,
  throwAppointment,
  isView,
  viewId,
  editId,
  setIsInstitutionPatient,
  billType,
  isInstitutionPatient,
  setInvoiceData,
}) => {
  const [clinic] = useAtom(clinicAtom);
  const [searchInput, setSearchInput] = useState({
    injury: "",
    ipd: "",
    opd: "",
    customer: "",
    patient: "",
  });

  const invoiceDate = displayData?.invoice_date
    ? moment(displayData?.invoice_date).format("DD MMMM YYYY")
    : moment().format("DD MMMM YYYY");

  const dueDate = displayData?.institution_customer?.payment_terms?.due_days
    ? moment(invoiceDate)
        .add(displayData?.institution_customer?.payment_terms?.due_days, "days")
        .format("D MMMM YYYY")
    : "";

  const handleInvoiceDate = (e) => {
    handleChange(e.target.value, "invoice_date");
  };

  const modifyPatientData = (response) => {
    if (response?.data?.length > 0 && response.data[0]?.patients) {
      const modifiedData = response.data[0].patients?.map((pt) => {
        return {
          age: pt?.age,
          dob: pt?.dob,
          full_name: pt?.full_name,
          gender: pt?.gender,
          id: pt?.id,
          phone: pt?.phone,
        };
      });
      return modifiedData || [];
    } else {
      return response.data;
    }
  };

  const modifyInjuryData = (response) => {
    const modifiedData = response?.data?.map((inj) => {
      return {
        slotId: inj?.id,
        injuryNo: inj?.custom_field_1?.value,
        id:
          inj?.consultation_data?.length > 0
            ? inj?.consultation_data[0]?.id
            : null,
        opd_number:
          inj?.consultation_data?.length > 0
            ? inj?.consultation_data[0]?.opd_number
            : "",
        date:
          inj?.consultation_data?.length > 0
            ? moment(
                inj?.consultation_data[0]?.opd_date ||
                  inj?.consultation_data[0]?.date_created
              ).format("DD MMMM YYYY")
            : moment().format("DD MMMM YYYY"),
      };
    });
    return modifiedData || [];
  };

  const queryForCustomerData = `?action=getInstitutionCustomers&frontend=True&clinic_id=${clinic?.id}&institution_name__icontains=${searchInput.customer}`;
  const { data: customerData, isLoading: customerLoading } = useItemsFilter(
    ApiEndPoint.INSTITUTION_CUSTOMERS,
    queryForCustomerData,
    searchInput?.customer?.length > 0 ? true : false,
    "invoice"
  );

  const queryForInstitutionPatient = `?clinic_id=${clinic?.id}&backend=True&action=getUsers&email=${searchInput?.patient}@institute${displayData?.institution_customer?.id}.com`;
  const queryForPatient = `?action=getSearchPatient&clinic_id=${clinic?.id}&backend=True&family_id=${searchInput?.patient}`;

  const { data: patientData, isLoading: patientLoading } = useItemsFilterNew(
    ApiEndPoint.USERS,
    isInstitutionPatient ? queryForInstitutionPatient : queryForPatient,
    searchInput?.patient?.length === 10 && clinic?.id ? true : false,
    modifyPatientData
  );

  const { data: customFields, isLoading: customFieldsLoading } = useItemsFilter(
    "clinics/custom_fields_value/",
    `?action=getCustomFields&clinic_id=${clinic?.id}&backend=True&module_name=book_appointment`,
    clinic?.id ? true : false
  );

  const { data: injuryData, isLoading: injuryLoading } = useItemsFilterNew(
    ApiEndPoint.BOOKING,
    `?action=getSlots&clinic_id=${clinic?.id}&backend=True&patient_id=${displayData?.patient_details?.id}&injury_no=${searchInput?.injury}`,
    clinic?.id &&
      displayData?.patient_details?.id &&
      searchInput?.injury?.length > 0
      ? true
      : false,
    modifyInjuryData
  );

  const { data: ipdData, isLoading: ipdLoading } = useItemsFilter(
    ApiEndPoint.IPD,
    `?action=getIpds&backend=True&clinic_id=${clinic?.id}&user_details=${displayData?.patient_details?.id}&ipd_number=${searchInput?.ipd}`,
    clinic?.id &&
      displayData?.patient_details?.id &&
      searchInput?.ipd?.length > 0
      ? true
      : false
  );

  const { data: opdData, isLoading: opdLoading } = useItemsFilter(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    `?action=getConsultationData&clinic_id=${clinic?.id}&backend=True&opd_number=${searchInput?.opd}&patients_id_all=${displayData?.patient_details?.id}`,
    clinic?.id &&
      displayData?.patient_details?.id &&
      searchInput?.opd?.length > 0
      ? true
      : false
  );

  const clearSearch = () => {
    setSearchInput({
      injury: "",
      ipd: "",
      opd: "",
      customer: "",
      patient: "",
    });
  };

  const handleSearch = (val, label) => {
    setSearchInput({
      injury: "",
      ipd: "",
      opd: "",
      customer: "",
      patient: "",
      [label]: val,
    });
  };

  const handleInstitution = () => {
    setIsInstitutionPatient((prev) => !prev);
    setInvoiceData((prev) => ({
      ...initialState,
      invoice_no: prev?.invoice_no,
      clinic_id: clinic?.id,
    }));
  };

  const handleInstitutionSearch = (value) => {
    setInvoiceData((prev) => ({
      ...prev,
      institution_customer: {
        ...prev?.institution_customer,
        institution_name: value,
      },
    }));
    handleSearch(value, "customer");
  };

  const handlePatientSearch = (value) => {
    if (value?.length > 10) {
      return;
    }
    if (isInstitutionPatient && !displayData?.institution_customer?.id) {
      toast.error("Please select customer first");
      return;
    }
    setInvoiceData((prev) => ({
      ...prev,
      patient_details: { phone: value, full_name: "", id: null },
    }));
    handleSearch(value, "patient");
  };

  const handleInjurySearch = (value) => {
    if (!displayData?.patient_details?.id) {
      toast.error("Please select patient first");
      return;
    }
    setInvoiceData((prev) => ({
      ...prev,
      admission_details: {
        ...prev?.admission_details,
        injury_no: value,
      },
    }));
    handleSearch(value, "injury");
  };

  const handleIPDSearch = (value) => {
    // if (
    //   isInstitutionPatient &&
    //   (!displayData?.admission_details?.injury_no || !displayData?.slot_id)
    // ) {
    //   toast.error("Please select injury number first");
    //   return;
    // }
    if (!isInstitutionPatient && !displayData?.patient_details?.id) {
      toast.error("Please select patient first");
      return;
    }
    setInvoiceData((prev) => ({
      ...prev,
      admission_details: {
        ...prev?.admission_details,
        IPD_No: value,
      },
    }));
    handleSearch(value, "ipd");
  };

  const handleOPDSearch = (value) => {
    // if (
    //   isInstitutionPatient &&
    //   (!displayData?.admission_details?.injury_no || !displayData?.slot_id)
    // ) {
    //   toast.error("Please select injury number first");
    //   return;
    // }
    // if (
    //   !isInstitutionPatient &&
    //   billType === "IPD" &&
    //   (!displayData?.admission_details?.IPD_No ||
    //     !displayData?.admission_details?.ipd_id)
    // ) {
    //   toast.error("Please select IPD number first");
    //   return;
    // }
    setInvoiceData((prev) => ({
      ...prev,
      opd: { ...prev?.opd, opd_number: value },
    }));
    handleSearch(value, "opd");
  };

  const handleSelectCustomer = (customer) => {
    setInvoiceData((prev) => ({
      ...prev,
      institution_customer: customer,
    }));
    clearSearch();
  };

  const handleSelectPatient = (patient) => {
    setInvoiceData((prev) => {
      return { ...prev, patient_details: patient };
    });
    clearSearch();
  };

  const handleSelectInjury = (value) => {
    setInvoiceData((prev) => ({
      ...prev,
      slot_id: value?.slotId,
      admission_details: {
        ...prev?.admission_details,
        injury_no: value?.injuryNo,
      },
      opd: { id: value?.id, opd_number: value?.opd_number, date: value?.date },
    }));
    clearSearch();
  };

  const handleSelectIpd = (value) => {
    if (displayData?.slot_id) {
      if (displayData?.slot_id !== value?.slot) {
        toast.error(
          "This IPD is not connected with this injury number you can update your IPD by going to this injury appointment"
        );
        return;
      }
    }

    setInvoiceData((prev) => ({
      ...prev,
      admission_details: {
        ...prev?.admission_details,
        IPD_No: value?.ipd_number,
        ipd_id: value?.id,
      },
      slot_id: value?.slot,
    }));
    clearSearch();
  };

  const handleSelectOpd = (val) => {
    if (displayData?.slot_id) {
      if (displayData?.slot_id !== val?.slot_id) {
        toast.error("This OPD is not connected with this injury or IPD number");
        return;
      }
    }

    setInvoiceData((prev) => ({
      ...prev,
      opd: {
        id: val?.id,
        opd_number: val?.opd_number,
        date: moment(val?.opd_date || val?.date_created).format("DD MMMM YYYY"),
      },
      slot_id: val?.slot_id,
    }));
    clearSearch();
  };

  const handleClear = (val, label) => {
    if (isView || throwAppointment) {
      return;
    }
    if (label === "injury_number" || label === "IPD" || label === "OPD") {
      setInvoiceData((prev) => ({
        ...prev,
        admission_details: {
          ...prev?.admission_details,
          injury_no: "",
          IPD_No: "",
          ipd_id: null,
        },
        slot_id: null,
        opd: {
          id: null,
          opd_number: "",
          date: moment().format("DD MMMM YYYY"),
        },
      }));
      return;
    }
    if (label === "institution_customer") {
      setInvoiceData((prev) => ({
        ...prev,
        institution_customer: {
          id: null,
          institution_name: "",
          contact_person_name: "",
          contact_number: "",
          email_address: "",
          billing_address: {
            building_name: "",
            street_address: "",
            city: "",
            pincode: "",
          },
          communication_address: {
            building_name: "",
            street_address: "",
            city: "",
            pincode: "",
          },
          payment_terms: {
            id: null,
            due_days: null,
          },
        },
        patient_details: {
          id: null,
          full_name: "",
          phone: "",
        },
        admission_details: {
          ...prev?.admission_details,
          injury_no: "",
          IPD_No: "",
        },
        opd: {
          id: null,
          opd_number: "",
          date: moment().format("DD MMMM YYYY"),
        },
        slot_id: null,
      }));
      return;
    }
    if (label === "patient_details") {
      setInvoiceData((prev) => ({
        ...prev,
        patient_details: {
          id: null,
          full_name: "",
          phone: "",
        },
        admission_details: {
          ...prev?.admission_details,
          injury_no: "",
          IPD_No: "",
          ipd_id: null,
        },
        opd: {
          id: null,
          opd_number: "",
          date: moment().format("DD MMMM YYYY"),
        },
        slot_id: null,
      }));
      return;
    }
  };

  return (
    <div className="cu-pgeneral-info-div">
      <div className="cu-pgeneral-info-heading">
        <span>
          <img
            src={cufrontIcons.settingsActive}
            alt="..."
            width={"23.35px"}
            height={"24px"}
          />
        </span>
        <span className="cu-create-invoice-heading-text">General Info</span>
      </div>
      <div style={{ marginTop: "5px" }}>
        <div className="flex items-center gap-3">
          <label>Institution Patient</label>
          <input
            type="checkbox"
            checked={isInstitutionPatient}
            disabled={viewId || editId || throwAppointment}
            onChange={handleInstitution}
          />
        </div>
        {isInstitutionPatient && (
          <div className="flex items-end gap-2">
            <div className="flex-1">
              <CuSuggestionBox
                options={customerData?.data}
                placeholder="Search Customer"
                disabled={
                  isView || displayData?.institution_customer?.id ? true : false
                }
                renderKey="institution_name"
                searchable={true}
                label="Customer"
                searchInput={searchInput?.customer}
                setSearchInput={() => {}}
                value={displayData?.institution_customer?.institution_name}
                onChange={handleInstitutionSearch}
                handleSelectOption={handleSelectCustomer}
                required={true}
                loading={customerLoading}
                position="calc(50% + 4px)"
              />
            </div>
            <MdClear
              className="cursor-pointer"
              onClick={() => handleClear({}, "institution_customer")}
            />
          </div>
        )}
      </div>
      <div className="cu-pgeneral-invoice-number-main">
        <span>Invoice Number:</span>
        <span style={{ fontWeight: "bold" }}>{displayData?.invoice_no}</span>
      </div>

      <div className="mt-[10px] flex items-end gap-2">
        <div className="flex-1">
          <CuSuggestionBox
            options={patientData}
            placeholder="Search Patient"
            disabled={isView || displayData?.patient_details?.id ? true : false}
            renderKey="full_name"
            label={"Patient Mobile Number"}
            type="number"
            searchable={true}
            searchInput={searchInput?.patient}
            setSearchInput={() => {}}
            value={displayData?.patient_details?.phone}
            onChange={handlePatientSearch}
            handleSelectOption={handleSelectPatient}
            required={true}
            loading={patientLoading}
            position="calc(50% + 4px)"
          />
        </div>
        <MdClear
          className="cursor-pointer"
          onClick={() => handleClear({}, "patient_details")}
        />
      </div>
      <div className="cu-pgeneral-invoice-number-main">
        <span>Patient Name:</span>
        <span style={{ fontWeight: "bold" }}>
          {displayData?.patient_details?.full_name}
        </span>
      </div>
      {customFields?.map((cfield) => {
        return (
          cfield?.is_institution_customer_based === isInstitutionPatient && (
            <div className="mt-[10px] flex items-end gap-2" key={cfield?.id}>
              <div className="flex-1">
                <CuSuggestionBox
                  options={injuryData}
                  placeholder={`Search ${cfield?.display_name}`}
                  disabled={isView || displayData?.slot_id ? true : false}
                  renderKey="injuryNo"
                  label={cfield?.display_name}
                  type="text"
                  searchable={true}
                  searchInput={searchInput?.injury}
                  setSearchInput={() => {}}
                  value={displayData?.admission_details?.injury_no}
                  onChange={handleInjurySearch}
                  handleSelectOption={handleSelectInjury}
                  required={true}
                  loading={injuryLoading}
                  position="calc(50% + 4px)"
                />
              </div>
              <MdClear
                onClick={() => handleClear({}, "injury_number")}
                className="cursor-pointer"
              />
            </div>
          )
        );
      })}

      <div className="mt-[10px] flex items-end gap-2">
        <div className="flex-1">
          <CuSuggestionBox
            options={ipdData}
            placeholder={`Search IPD`}
            disabled={
              isView || displayData?.admission_details?.ipd_id ? true : false
            }
            renderKey="ipd_number"
            label={"IPD Number"}
            type="text"
            searchable={true}
            searchInput={searchInput?.ipd}
            setSearchInput={() => {}}
            value={displayData?.admission_details?.IPD_No}
            onChange={handleIPDSearch}
            handleSelectOption={handleSelectIpd}
            required={true}
            loading={ipdLoading}
            position="calc(50% + 4px)"
          />
        </div>
        <MdClear
          onClick={() => handleClear({}, "IPD")}
          className="cursor-pointer"
        />
      </div>

      <div className="mt-[10px] flex items-end gap-2">
        <div className="flex-1">
          <CuSuggestionBox
            options={opdData}
            placeholder={`Search OPD`}
            disabled={isView || displayData?.opd?.id ? true : false}
            renderKey="opd_number"
            label={"OPD Number"}
            type="text"
            searchable={true}
            searchInput={searchInput?.opd}
            setSearchInput={() => {}}
            value={displayData?.opd?.opd_number}
            onChange={handleOPDSearch}
            handleSelectOption={handleSelectOpd}
            required={billType === "OPD" ? true : false}
            loading={opdLoading}
            position="calc(50% + 4px)"
          />
        </div>
        <MdClear
          className="cursor-pointer"
          onClick={() => handleClear({}, "OPD")}
        />
      </div>
      <div className="cu-pgeneral-invoice-number-main">
        <span>OPD Date:</span>
        <span style={{ fontWeight: "bold" }}>{displayData?.opd?.date}</span>
      </div>
      <div className="cu-pgeneral-invoice-number-main">
        <span>Invoice Date:</span>
        <div>
          <span style={{ fontWeight: "bold" }}>{invoiceDate}</span>
          <span>
            <input
              className="cu-pgeneral-date-picker"
              type="date"
              onChange={handleInvoiceDate}
            />
          </span>
        </div>
      </div>
      {isInstitutionPatient && (
        <div className="cu-pgeneral-invoice-number-main">
          <span>Due Date:</span>
          <span style={{ fontWeight: "bold" }}>{dueDate}</span>
        </div>
      )}
    </div>
  );
};

export default PGeneralInfo;
